import styles from './VerticalNavItem.module.css'

import { Flex, Text } from '@radix-ui/themes'
import { LuChevronDown } from '@react-icons/all-files/lu/LuChevronDown'
import cn from 'clsx'
import React, { useCallback, useState } from 'react'
import { NavLink } from 'react-router-dom'

export type VerticalNavItemType = {
  active?: boolean
  disabled?: boolean
  expandable?: boolean
  expanded?: boolean
  items?: VerticalNavItemType[]
  label: React.ReactNode
  link?: string
  onClick?: () => void
}
export const VerticalNavItem = ({
  active,
  disabled,
  expandable,
  expanded,
  items,
  label,
  link,
  onClick,
}: VerticalNavItemType): React.ReactNode => {
  const [isExpanded, setIsExpanded] = useState<boolean>(expanded ?? true)
  const isHeader = Boolean(expandable && items && items.length > 0)
  const Element: React.ElementType = !disabled && link ? NavLink : 'div'
  const linkProps = link ? { to: link } : {}

  const handleClick = useCallback(() => {
    if (expandable) {
      setIsExpanded((isExpanded: boolean) => {
        if (link || onClick) {
          return true
        }

        return !isExpanded
      })
    }

    if (onClick) {
      onClick()
    }
  }, [expandable, link, onClick])
  const handleExpand = useCallback((event: React.SyntheticEvent<any>) => {
    event.preventDefault()
    event.stopPropagation()
    setIsExpanded((isExpanded: boolean) => !isExpanded)
  }, [])
  return (
    <>
      <Flex
        asChild
        align="center"
        className={cn(styles.component, {
          [styles.clickable]: !disabled && (expandable || link || onClick),
          [styles.disabled]: disabled,
          [styles.header]: isHeader,
        })}
        onClick={!disabled ? handleClick : undefined}
      >
        <Element {...linkProps}>
          <Text className={styles.label}>{label}</Text>
          {isHeader && (
            <span
              className={styles.expand}
              data-expanded={isExpanded || undefined}
              onClick={!disabled ? handleExpand : undefined}
            >
              <LuChevronDown size={16} />
            </span>
          )}
        </Element>
      </Flex>
      {items &&
        isExpanded &&
        items
          .map((item: VerticalNavItemType) => ({
            ...item,
            disabled: item.disabled ?? disabled,
          }))
          .map((item: VerticalNavItemType, index: number) => (
            <VerticalNavItem {...item} key={item.link ?? index} />
          ))}
    </>
  )
}
